import { render } from "./Periods.vue?vue&type=template&id=b7b902a2&scoped=true"
import script from "./Periods.vue?vue&type=script&lang=js"
export * from "./Periods.vue?vue&type=script&lang=js"

import "./Periods.vue?vue&type=style&index=0&id=b7b902a2&lang=scss&scoped=true"

import exportComponent from "/lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7b902a2"]])

export default __exports__